export function resolveMaxCommissioningYear(now = new Date()) {
    return now.getFullYear();
}
